<template>
  <div>
    <Search />
  </div>
</template>
